import { render, staticRenderFns } from "./1.vue?vue&type=template&id=326148e2&scoped=true"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"
import style0 from "./1.vue?vue&type=style&index=0&id=326148e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326148e2",
  null
  
)

export default component.exports